class a extends HTMLElement {
  constructor() {
    super(),
      (this.productForm = null),
      (this.option = {
        name: this.getAttribute('data-option-name'),
        position: Number(this.getAttribute('data-option-position')),
      }),
      (this.elements = {
        options: this.querySelectorAll('[data-option]'),
        fieldset: this.querySelector('[data-options-fieldset]'),
      });
  }
  connectedCallback() {
    const t = this.getAttribute('data-form-id');
    (this.productForm = document.querySelector(`product-form[data-form-id="${t}"]`)), this.handleVariantChange();
  }
  handleVariantChange() {
    const t = this.productForm.querySelector('input[name="id"]');
    t &&
      t.addEventListener('variant_update', (e) => {
        var o;
        (o = e.detail) != null && o.variant && this.updateOptions();
      });
  }
  updateOptions() {
    const t = this.productForm.getActiveOptions(this.option.name);
    this.elements.options.forEach((e) => {
      const i = e.getAttribute('data-value'),
        o = t.find((n) => n.options[this.option.position - 1] === i);
      this.updateOption(e, o);
    });
  }
  updateOption(t, e) {
    const i = t.querySelector('input[type="radio"]');
    e ? i.removeAttribute('disabled') : i.setAttribute('disabled', !0);
  }
}
function s() {
  customElements.define('component-variant-radios', a);
}
export {s as i};
